import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';

import { getCurrentMonth } from '../DashBoardHelper';
import noRecordFound from '../../../assets/images/empty-folder.png'

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAnnouncementlist } from '../../../redux/slices/announcementSlice';
import DOMPurify from "dompurify";
import { cleanAndTruncateText } from '../../../hooks/commonHooks';


import { Announcement, AnnouncementsProps } from './AnnouncementsTypes';

function Announcements(props: AnnouncementsProps) {

    const { title, announcementList } = props;

    const [currMonth, setCurrMonth] = useState<string>();
    const [loader, setLoader] = useState<boolean>(true);
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [scrollDirection, setScrollDirection] = useState<'up' | 'down'>('down');
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();


    useEffect(() => {
        setCurrMonth(getCurrentMonth());
        setTimeout(() => {
            setLoader(false);
        }, 3500);
    }, []);


    const handleNavigateToAnnouncement = (item: Announcement) => {
        if (item) {
            dispatch(setAnnouncementlist(item));
            navigate('/home/announcements/sent/single-announcements');
        }
    }



    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
            if (scrollTop + clientHeight >= scrollHeight) {
                setScrollDirection('up');
            } else if (scrollTop <= 0) {
                setScrollDirection('down');
            }
        };

        const scrollSpeed = 1.5;
        const intervalDelay = 10;
        let autoScroll: ReturnType<typeof setInterval> | null = null;

        if (!isHovered) {
            autoScroll = setInterval(() => {
                if (scrollDirection === 'down') {
                    scrollContainer.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
                } else {
                    scrollContainer.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
                }
                handleScroll();
            }, intervalDelay);
        }

        return () => {
            if (autoScroll) clearInterval(autoScroll);
        };
    }, [scrollDirection, isHovered]);

    const handleMouseOver = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);


    const renderAnnouncement = (item: Announcement) => {
        const sanitizeAnnouncementContent = (announcementContent: string) => {
            const sanitizedBody = announcementContent ? DOMPurify.sanitize(announcementContent) : '';
            return sanitizedBody;
        }
        const plainTextBody = item && item.body ? item.body : '';

        const truncatedBody = cleanAndTruncateText(plainTextBody);
        return (
            <div className={`birth-anniversary__list-cont items-center cursor-pointer hover:text-[#d34a7c]`}
                onClick={() => {
                    handleNavigateToAnnouncement(item)
                }}>
                <div className='birth-anniversary__profile-img flex justify-center items-center'>
                    <span className="material-symbols-outlined text-[#d23b7d]">
                        campaign
                    </span>
                </div>
                <div className=' birth-anniversary__emp-hooray flex cursor-pointer hover:text-[#d34a7c]'>
                    <span>
                        {item?.subject?.length > 20 ? (
                            <Tooltip title={item?.subject} overlayStyle={{ maxWidth: '500px' }} >
                                <p className='dashboard-announce-body hover:text-[#d34a7c] ' > {item?.subject}</p>
                            </Tooltip>
                        ) : (
                            <p className='dashboard-announce-body hover:text-[#d34a7c]' > {item?.subject}</p>
                        )}
                    </span>

                    <span className='dashboard-announce-body hover:text-[#d34a7c]'>
                        <div dangerouslySetInnerHTML={{ __html: sanitizeAnnouncementContent(truncatedBody) }} className='hover:text-[#d34a7c]' />
                    </span>
                </div>

            </div>
        )
    }

    return (
        <div className='birth-anniversary relative'>

            <div className='birth-anniversary__tab flex justify-between relative top-4'>
                <div className='card-title justify-start'>
                    <h4>{title}</h4>
                </div>
                <div className='expand expand-icon justify-end text-primary'>

                </div>
            </div>

            {
                announcementList?.data?.length > 0 ? (
                    <div
                        ref={scrollContainerRef}
                        onMouseOver={handleMouseOver}
                        onMouseLeave={handleMouseLeave}
                        className='  overflow-y-auto  mt-12 announcement-notification-container'>
                        <ul className='birth-anniversary__AnnouncementTimeline announcement-notification-content' id="anniversary">
                            {announcementList?.data?.slice(0, 3).map((item: Announcement, index: number) => {
                                const currDate = new Date(item.updatedOn).getDate();
                                const currMonth = new Date(item.updatedOn).toLocaleString('default', { month: 'short' });

                                // Determine if the previous item's date differs from the current item's date
                                const prevDate =
                                    index > 0
                                        ? new Date(announcementList.data[index - 1]?.updatedOn).getDate()
                                        : null;

                                return (
                                    <li
                                        key={`${item.emailAnnouncementId}+${index}`}
                                        className="birth-anniversary__lists relative"
                                        id={`date-${currDate}`}
                                    >
                                        {prevDate !== currDate && (
                                            <div className="date-header">
                                                <span className="birth-anniversary__date absolute items-center flex justify-center">
                                                    {currDate}
                                                </span>
                                                <span className="birth-anniversary__month absolute">
                                                    {currMonth}
                                                </span>
                                            </div>
                                        )}
                                        <div className="announcement-content">
                                            {renderAnnouncement(item)}
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ) : (
                    <div className="no-record salary">
                        <p className='flex justify-center items-center text-xl'> <img src={noRecordFound} alt="" />
                        </p>
                    </div>
                )
            }
        </div >
    );
}

export default Announcements;
